import AuthenticationType from '@alltrails/analytics/enums/AuthenticationType';
import User from '@alltrails/shared/types/User';
import { authSuccessCallback } from './AuthHandlers';
import { appleConstants } from '../Constants';

// Note: This handler works differently than the others, where the user is redirected to
// an Apple login page and then redirected back to AllTrails.
// Because of this, there is a tracking callback implemented in GlobalActions
// that tracks that the signup/login redirect was successful.
const appleHandler = ({ redirectTo, referralLink }: { redirectTo?: string; referralLink?: string } = {}) => {
  const redirectURI = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${
    appleConstants.REDIRECT_PATH
  }`;

  const params = new URLSearchParams();
  params.set('client_id', appleConstants.CLIENT_ID);
  params.set('redirect_uri', redirectURI);
  params.set('scope', appleConstants.SCOPES);

  if (redirectTo || referralLink) {
    params.set('state', JSON.stringify({ ...(referralLink && { referral_code: referralLink }), ...(redirectTo && { redirect_to: redirectTo }) }));
  }

  const authUrl = `${appleConstants.AUTHORIZE_URL + appleConstants.AUTHORIZE_PARAMS}&${params}`;

  window.location.href = authUrl;
};

const appleRedirectHandler = (user: User) => {
  const params = new URLSearchParams(window.location.search);
  const appleOAuth = params.get('apple_oauth');
  const isCollabListInvite = params.has('is_collab_list_invite');
  if (appleOAuth) {
    const is_sign_up = appleOAuth === 'signup';
    authSuccessCallback({ is_sign_up, user }, AuthenticationType.Apple, isCollabListInvite);
    const search = params.toString();
    window.history.replaceState(null, null, window.location.pathname + (search !== '' ? `?${search}` : ''));
  }
};

export { appleHandler, appleRedirectHandler };
